import { Cart, Location, Shop } from 'Types'
import { isCategoryAllowed, CMP_CATEGORIES } from 'Utils/privacy'

export const sendKlaviyoPurchaseEvent = (cart: Cart, location: Location, shop: Shop): void => {
  // Klaviyo is a marketing platform — without Marketing consent the event must
  // not even be queued (window.klaviyo is an async queue: items pushed before
  // consent would be sent later if the user grants consent mid-session).
  if (!isCategoryAllowed(CMP_CATEGORIES.MARKETING)) return
  if (!cart.fulfillment?.currentFulfillmentAt) return

  // @ts-ignore: ignore klaviyo declaration
  window.klaviyo = window.klaviyo ?? []

  // Fulfillment date
  const fulfillmentDate = new Date(cart.fulfillment.currentFulfillmentAt)

  const items = cart.cartItems.map((item) => {
    return {
      id: `P${item.id}`,
      name: item.name,
      image_url: item.coverSerializableHash.url,
      list_name: item.categoryName,
      brand: item.name,
      category: item.type || '',
      variant: item.variantName || '',
      list_position: item.menuId,
      quantity: item.quantity,
      price: `${item.totalPrice}`,
    }
  })

  // @ts-ignore: ignore klaviyo declaration
  window.klaviyo.push([
    'track',
    'Purchase',
    {
      transaction_id: `T_${cart.id}`,
      affiliation: 'Online Ordering',
      value: cart.totalMoney,
      currency: shop.currency || 'CAD',
      tax: cart.totalTaxAndFeesMoney,
      shipping: cart.totalDeliveryCostMoney,
      location: location?.name || '',
      fulfillment_type: cart.fulfillment?.kind || '',
      fulfillment_date: fulfillmentDate,
      items,
    },
  ])
}
